export function detectFormType(
  formId: string | undefined
): "hubspot" | "eventbrite" | "splash" | "unknown" {
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  const numericRegex = /^[0-9]+$/;

  if (!formId) return "unknown";

  if (uuidRegex.test(formId)) {
    return "hubspot";
  }

  if (numericRegex.test(formId)) {
    return "eventbrite";
  }

  return "splash";
}
